import React from 'react'
import Button from '../buttons/Button'
import { useSelector } from 'react-redux';


const TermandConditions = ({ handleAccept, handleDecline }) => {

    const { isVisualizePageVisible } = useSelector((state) => state.createImage);
    return (
        <div className='max-w-[500px]'>

            <div className="flex flex-col justify-center">
                <div className="space-y-2 pt-10 pl-10 pr-10 pb-6 ">
                    <h2 className="font-helveticaText-Bold text-[28px] tracking-normal">
                        Terms of Service
                    </h2>
                    <div className="text-[20px] font-helveticaText-Medium  ">
                        Welcome to Monotype Portrait - an image generation service.
                    </div>
                </div>

                <div className='px-[40px] text-justify tracking-wide'>
                    <p >
                        To use this service, please review and accept our
                        <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>
                            &nbsp; terms and conditions.&nbsp;
                        </a>
                        By continuing, you agree to these terms.
                    </p>
                </div>


                <div className="flex  gap-[16px] px-10 pt-6 pb-10  ">
                    <Button onClick={handleDecline} label='Decline' className="bg-gray-light w-full hover:bg-gray-hoverLight text-cus_primary " />
                    <Button onClick={handleAccept} label='Accept & Continue' className="bg-blue-primary w-full hover:bg-blue-dark text-white  " />
                </div>

            </div>
        </div>
    )
}

export default TermandConditions